<div class="hub-calendar">
    <ig-water-fall-container #waterFallContainer
                             [hidden]="isNoContent"
                             [itemWidth]="270"
                             [maxColumnCount]="6"
                             [isAllItemsLoaded]="isAllDataLoaded"
                             (onLoadMore)="loadMore()">

        <ng-container *ngIf="actionCommand?.isEventCalendar">
            <ig-hub-event-card *ngFor="let event of events"
                               [event]="event" [isItineraryOn]="featuresToggle.itinerary"></ig-hub-event-card>
        </ng-container>
        <ng-container *ngIf="!actionCommand?.isEventCalendar">
            <ig-hub-place-card *ngFor="let place of places" [notAllowed]="actionCommand.queryParams.noFilter&&notAllowed(place)"
                               [place]="place" [isItineraryOn]="featuresToggle.itinerary"></ig-hub-place-card>
        </ng-container>

    </ig-water-fall-container>

    <ng-container>
        <ig-page-spinner #spinner></ig-page-spinner>
    </ng-container>

    <ig-no-content *ngIf="isNoContent"></ig-no-content>
</div>



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/calendar/hub.calendar.component.html